export default "__VITE_ASSET__B3ROgtF1__"